import { useQuery } from '@tanstack/react-query';
import PropTypes from 'prop-types';

import ErrorBoundary from 'components/ErrorBoundary';

import { topbarQueryKeys } from 'lib/queryKeys';

import { getNavbarAds } from 'services/ads';

import NavItem from './NavItem';

const SponsoredAds = ({ gaEventCategory }) => {
  const { data: navbarAds = [], isLoading } = useQuery({
    queryKey: topbarQueryKeys.navbarAds(),
    queryFn: ({ signal }) => getNavbarAds({ signal }),
    select: (data) => data.sort((a, b) => a.position - b.position),
    enabled: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

  if (isLoading || navbarAds?.length === 0) {
    return null;
  }

  return (
    <ErrorBoundary>
      {navbarAds.map(
        ({
          id,
          description,
          image,
          notificationIcon,
          sameTab,
          event,
          title,
          url,
        }) => (
          <NavItem
            key={id}
            gaEventAction={event || `${title}_tab`}
            gaEventCategory={gaEventCategory}
            imageProps={{
              src: image,
              alt: description,
            }}
            sameTab={sameTab}
            text={title}
            unreadStatus={notificationIcon}
            url={url}
          />
        )
      )}
    </ErrorBoundary>
  );
};

SponsoredAds.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default SponsoredAds;
